/** Every admin-chat pointer's localStorage key starts with it; sign-out clears them all. */
export const ADMIN_CHAT_STORAGE_PREFIX = "primepoint.adminChat.";

/**
 * Where one person's admin-chat pointer for one document of one project lives: the project key
 * (`localScopeSlug`, so the HBW increments that share a drawing document keep apart, and a URL
 * tab and a legacy tab of one project share it), the admitted member (another person on this
 * browser never reads it) and the document. Null until all three are known.
 */
export function adminChatStorageKey(
    projectKey: string | null,
    memberId: string | undefined,
    documentId: string | null | undefined,
): string | null {
    return projectKey && memberId && documentId
        ? `${ADMIN_CHAT_STORAGE_PREFIX}${projectKey}:${memberId}:${documentId}`
        : null;
}
